export enum DiscountCalculationType {
  Percentage = 0,
  FixedAmount = 1,
  FixedPrice = 2,
}
